export default __webpack_public_path__ + "static/media/happy-students.e663cb0b.png";